// src/components/AboutSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  { icon: 'fa-map-location-dot', title: 'PAN-INDIA', sub: 'SOURCING' },
  { icon: 'fa-leaf', title: 'CUSTOMISED', sub: 'SOLUTIONS' },
  { icon: 'fa-boxes-stacked', title: 'CONSOLIDATED', sub: 'PROCUREMENT' },
  { icon: 'fa-globe', title: 'FROM SOURCING', sub: 'TO SHIPMENT' },
];

const PROMISE = [
  { icon: 'fa-droplet', title: 'Preserve.' },
  { icon: 'fa-shield-halved', title: 'Standardise.' },
  { icon: 'fa-puzzle-piece', title: 'Tailor.' },
  { icon: 'fa-handshake', title: 'Deliver.' },
];

const AboutSection = () => {
  return (
    <section className="page-content grey">
      <div className="container">
        <div className="row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="col-lg-6 col-md-12">
            <p style={{ color: 'var(--brand-gold)', fontWeight: 700, letterSpacing: 1, marginBottom: 6 }}>WHO WE ARE</p>
            <h2 style={{ color: 'var(--brand-cream)', fontSize: 34, lineHeight: 1.25, marginBottom: 8 }}>THE POWER OF SPICE</h2>
            <h2 style={{ color: 'var(--brand-gold-light)', fontSize: 34, lineHeight: 1.25, marginBottom: 20 }}>THE PRECISION OF SCIENCE</h2>
            <p style={{ marginBottom: 14 }}>
              Cornerstone is a Pan-India merchant exporter and one-stop sourcing partner, connected with a
              wide network of reliable manufacturers and suppliers across different geographic regions of India.
            </p>
            <p style={{ marginBottom: 14 }}>
              Our strength lies in offering customised products tailored to our customers' specific requirements,
              while also sourcing a diverse range of raw materials directly from the most suitable production hubs.
              We can assort multiple products from different manufacturers into a single consolidated shipment.
            </p>
            <p style={{ marginBottom: 24 }}>
              With our strong sourcing network, product flexibility and commitment to quality, we provide
              one-stop solutions from sourcing to shipment.
            </p>
            <Link className="default-button01" to="/about/overview">READ MORE</Link>

            <div className="row" style={{ marginTop: 36 }}>
              {FEATURES.map((f, i) => (
                <div className="col-6 col-md-3" key={i} style={{ textAlign: 'center', marginBottom: 20 }}>
                  <i className={`fas ${f.icon}`} style={{ fontSize: 26, color: 'var(--brand-gold)', marginBottom: 10, display: 'block' }}></i>
                  <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.5, color: 'var(--brand-cream)' }}>{f.title}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.5, color: 'var(--brand-cream)' }}>{f.sub}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <img
              alt="Natural spices and extraction process"
              src="/assets/images/brand/about_spices.jpg"
              style={{ width: '100%', maxHeight: 560, objectFit: 'cover', objectPosition: 'top', borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.4)' }}
            />
          </div>
        </div>

        <div
          className="row"
          style={{
            marginTop: 40,
            border: '1px solid var(--brand-gold)',
            borderRadius: 10,
            padding: '24px 10px',
          }}
        >
          <div className="col-12" style={{ textAlign: 'center', marginBottom: 18 }}>
            <span style={{ color: 'var(--brand-gold)', fontFamily: 'var(--brand-heading-font)', fontSize: 20, letterSpacing: 1 }}>OUR PROMISE</span>
          </div>
          {PROMISE.map((p, i) => (
            <div className="col-6 col-md-3" key={i} style={{ textAlign: 'center' }}>
              <i className={`fas ${p.icon}`} style={{ fontSize: 22, color: 'var(--brand-gold-light)', marginBottom: 8, display: 'block' }}></i>
              <div style={{ color: 'var(--brand-cream)', fontWeight: 600 }}>{p.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
